/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-22 11:37:17
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-05 14:52:36
 */

const secondColonelManageMenus = [
	{
		path: '/secondColonelManage',
		component: null,
		name: '活动',
		// meta: { isMenu: true, title: '活动', icon: 'i-home' },
		id: 2,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: true,
		useTemplate: false,
		redirect: '/secondColonelManage/promotion',
		children: [
			{
				component: null,
				icon: 'system',
				id: 6,
				keepAlive: false,
				name: '千团优选',
				parentId: 2,
				path: 'promotion',
				showBread: true,
				useTemplate: true,
				visible: true,
				redirect: '/secondColonelManage/promotion/list',
				children: [
					{
						component: 'secondColonelManage/productPromotion/list/index',
						icon: 'system',
						id: 60,
						keepAlive: false,
						name: '协作申请列表',
						parentId: 59,
						path: 'list',
						showBread: false,
						useTemplate: false,
						visible: true,
					},
				],
			},
			{
				path: 'releasePlatform',
				component: 'secondColonelManage/releasePlatform',
				name: '热度放单平台',
				parentId: 2,
				showBread: true,
				useTemplate: false,
				visible: true,
				children: null,
			},
			{
				path: 'myActivities',
				component: null,
				name: '我的招商活动',
				id: 4,
				parentId: 2,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/secondColonelManage/myActivities/list',

				children: [
					{
						path: 'list',
						parentId: 4,
						component: 'secondColonelManage/myActivities/list',
						name: '热度放单平台',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'detail',
						parentId: 4,
						component: 'secondColonelManage/myActivities/detail',
						name: '招商活动详情',
						showBread: true,
						useTemplate: true,
						visible: true,
						children: null,
					},
				],
			},
			{
				path: 'colonelActivitySquare',
				component: null,
				id: 5,
				parentId: 2,
				name: '团长活动广场',
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/secondColonelManage/colonelActivitySquare/list',
				children: [
					{
						path: 'list',
						parentId: 5,
						component: 'secondColonelManage/colonelActivitySquare/list',
						name: 'list',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'detail',
						name: '团长活动详情',
						parentId: 5,
						component: 'secondColonelManage/colonelActivitySquare/detail',
						showBread: true,
						useTemplate: false,
						visible: true,
						children: null,
					},
				],
			},
			{
				path: 'cooperativeColonel',
				component: null,
				id: 6,
				parentId: 2,
				name: '合作团长',
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/secondColonelManage/cooperativeColonel/list',
				children: [
					{
						path: 'list',
						name: '团长活动详情',
						parentId: 6,
						component: 'secondColonelManage/cooperativeColonel/list',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'detail',
						name: '团长详情',
						parentId: 6,
						component: 'secondColonelManage/cooperativeColonel/detail',
						showBread: false,
						useTemplate: false,
						visible: true,
						children: null,
					},
				],
			},
			{
				path: 'rulesSetting',
				component: null,
				id: 7,
				parentId: 2,
				name: '规则设置',
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
				redirect: '/secondColonelManage/rulesSetting/viewRules',
				children: [
					{
						path: 'viewRules',
						name: '规则管理',
						parentId: 7,
						component: 'secondColonelManage/rulesSetting/viewRules',
						showBread: true,
						useTemplate: false,
						visible: true,
						children: null,
					},
					{
						path: 'editRules',
						name: '编辑规则',
						parentId: 7,
						component: 'secondColonelManage/rulesSetting/editRules',
						showBread: true,
						useTemplate: false,
						visible: true,
						children: null,
					},
				],
			},
		],
	},
];
export default secondColonelManageMenus;
